export default {
  scrollFade: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    pointerEvents: 'none'
  }
}
